export default __webpack_public_path__ + "static/e8c8493ba2f740674a6a0afda70859cc.jpg";